type Scene = Record<string, unknown>;
type DataRow = Record<string, string>;
type RenderedTemplate = {
  templateId: string;
  width: number;
  height: number;
  png: string;
  pdfPng?: string;
};

type RenderBatchesOptions = {
  rows: Array<DataRow | undefined>;
  buildScene: (row: DataRow | undefined) => Scene;
  renderScene: (scene: Scene) => Promise<RenderedTemplate[]>;
};

/** Render each request-scoped row in order so ZIP suffixes stay deterministic. */
export async function renderServerExportBatches({
  rows,
  buildScene,
  renderScene,
}: RenderBatchesOptions) {
  if (!Array.isArray(rows) || rows.length === 0) {
    throw new Error("Server export has no scene rows");
  }
  const batches = [];
  for (let index = 0; index < rows.length; index += 1) {
    const row = rows[index];
    batches.push({
      templates: await renderScene(buildScene(row)),
      suffix: row === undefined ? "" : `-row${String(index + 1).padStart(2, "0")}`,
    });
  }
  return batches;
}
